import { dependency } from '../../utils/request';
import { getData } from '../../utils/data';
/**
 * @module directives/form/recaptcha
 */

/**
 * Enhances forms with Google reCAPTCHA functionality. Requires use of the reCAPTCHA Craft plugin.
 */
export default function validatorDirective() {
  const recaptchaPath = 'https://www.google.com/recaptcha/api.js',
  forms = document.querySelectorAll('form[sw-recaptcha]');

    // Only load reCAPTCHA API if there are forms on the page
    if (forms.length > 0) {
        dependency(recaptchaPath, _ => {
      forms.forEach(form => {
        const recaptcha = form.querySelector('.g-recaptcha'),
        callbackName = form.getAttribute('sw-recaptcha');
                window[callbackName] = _ => {

          // Removes all recaptcha event listeners so the recaptcha doesn't resend when resubmitting.
          recaptcha.parentNode.replaceChild(recaptcha.cloneNode(true), recaptcha);

          // Submit via the form validator (if attached).
          const validator = getData(form, 'validator');
          if (validator) validator.submit();
          else form.submit();
                }
            });
        }, _ => window.grecaptcha);
    }
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/recaptcha.js